import script from "./ScheduleDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleDataTable.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleDataTable.vue?vue&type=style&index=0&id=65180e82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65180e82"]])

export default __exports__